export default function initHowItWorksVideo() {
   const playerElementId = "hp2-howitworks-video-frame";
   const playButton = document.getElementById("hp2-howitworks-video-button");
   let playerElement = document.getElementById(playerElementId);

   if (playButton && playerElement) {
      let player: YT.Player;
      LSHelper.Youtube.init(() => {
         if (player == null) {
            player = new YT.Player(playerElementId, {
               videoId: "vOWIJHOTw3I",
               events: {
                  onReady: ev => {
                     playerElement = document.getElementById(playerElementId);
                  },
                  onStateChange: e => {
                     if (e.data == YT.PlayerState.ENDED) {
                        playerElement && (playerElement.style.zIndex = "-1");
                     }
                  }
               }
            });
         }
      });

      playButton.addEventListener("click", () => {
         playerElement && (playerElement.style.zIndex = "3");
         player.playVideo();
      });
   }
}